import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Auth0Notification = ({ type, isGlobal, children, icon }) => {
  const budicon = icon || {
    primary: 'icon-budicon-764',
    danger: 'icon-budicon-354',
    warning: 'icon-budicon-115'
  }[type];

  const outerClasses = classNames({
    'auth0-notification-global': isGlobal,
    'auth0-notification': !isGlobal,
  }, type);

  const innerClasses = isGlobal && 'container';

  const iconClasses = classNames(
    'notification-icon',
    budicon
  );

  return (
    <div className={outerClasses}>
      <div className={innerClasses} style={{ display: 'flex' }}>
        <i className={iconClasses} style={{ marginTop: '5px' }}/>
        <p>{children}</p>
      </div>
    </div>
  );
};

Auth0Notification.propTypes = {
  type: PropTypes.oneOf([
    'primary',
    'danger',
    'warning'
  ]).isRequired,
  icon: PropTypes.string,
  isGlobal: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.array
  ])
};

export default Auth0Notification;
